import { createActions } from "redux-actions";

export default createActions({
  SERVICE: {
    INDEX_OF_SIGNED_IN: {
      SET: (
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        currentUser,
        serviceName
      ) => ({
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        currentUser,
        serviceName,
      }),
    },
  },
});
